<template>
  <div class="card participant-list">
    <h2 class="card__title">
      {{ $t('our_donors.title') }}
    </h2>

    <PagesProjectParticipant
      v-for="participant in participants"
      :key="participant.id"
      :participant="participant"
      :locale="locale"
    />

    <PagesProjectParticipantsModal
      v-if="participantsCount > 5"
      :locale="locale"
      :project-id="projectId"
      :participants-count="participantsCount"
    />
  </div>
</template>

<script setup>
defineProps({
  projectId: {
    type: String,
    required: true,
  },
  participants: {
    type: Array,
    default: () => [],
  },
  participantsCount: {
    type: Number,
    default: 0,
  },
  locale: {
    type: String,
    default: 'en',
  },
});
</script>

<style lang="scss">
@use '@styles/components/pages/project/participant.scss' as *;
</style>
